import React ,{useState,useEffect}from 'react'
import { Button } from '@mui/material';
import { Row,Col } from "antd";
import { useGetBuyersListQuery } from 'features/Procurement/common/ProcurementApiSlice'
import SendIcon from '@mui/icons-material/Send';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import {  Spinner } from "reactstrap";
import { useAssignByAdminForFarmersMutation } from '../EMandiApiSlice';
import { toast } from 'react-toastify';
export const BuyerListMandi = ({tradeData,setModalOpen}) => {
  
    const[BuyersList,setBuyersList]=useState([])
    const [filterIdAgain, setFilterIdAgain] = useState([]);
   const[loading,setLoading]=useState(false)
   const [bidsPayload, setBidsPayload] = useState([]);
   const[assignByAdmin]=useAssignByAdminForFarmersMutation()
    let entity_type="Buyer"
    const { data: Buyers, isLoading } = useGetBuyersListQuery(entity_type);

    useEffect(() => {
        const dataFromApi = Buyers?.data ? Buyers?.data : [];
        setBuyersList(dataFromApi);
      }, [Buyers]);
      console.log("BuyersList",BuyersList)
   
    
     
      const filterDataBasedId = (item) => {
        const selectedBuyers = BuyersList.filter(data => item.includes(data.id));
      console.log("selectedBuyers",selectedBuyers)
        const bidsArray = selectedBuyers.map(data => ({
          // id: data.id,
          id:data.user_id,
          type: "Buyer",  
          name: data.user_name,
          phone_number: data.user_mobile,
          delivery_address: data.address || "",
          user_id:data.user_id
        }));
    
        console.log("bidsPayload", bidsArray);
        setBidsPayload(bidsArray);
        setFilterIdAgain(item);  
      };
    
      const handleAssign = () => {
        setLoading(true)
        console.log("bidsPayload",bidsPayload)
          let payload = {
            trade_id:tradeData.id ,
            bids: bidsPayload,
          };
          assignByAdmin({ payload })
            .unwrap()
            .then(() => {
              toast.success("Successfully Assigned !!");
              setFilterIdAgain([]);
              setBidsPayload([])
              setLoading(false)
              setModalOpen(false)
            })
            .catch(() => {
              toast.error("Something went wrong !! We will get back soon");
              setLoading(false)
            });
        }
      
      const columnsBuyer = [
        { field: "user_name", headerName: "Name", width: 150 },
        { field: "address", headerName: "Address", width: 350 },
        { field: "email", headerName: "Email", width: 200 },
        { field: "user_mobile", headerName: "Phone Number", width: 150 },
      ];
  return (
    <div>
     
     <Row className="align-items-center">
  {filterIdAgain?.length === 0 && (
    <Col>
      <h6 className="text-warning">
       Assign Trade To Buyer
      </h6>
    </Col>
  )}
  <Col md="2" className='offset-md-9'>
    <Button
      variant="contained"
      endIcon={<SendIcon />}
      color="success"
      onClick={handleAssign}
      size="small"
      className="p-2"
      disabled={filterIdAgain?.length > 0 ? false : true}
      sx={{
        fontWeight: 'medium',
        borderRadius: '8px',
        boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      Assign {loading ? <Spinner size="sm" /> : ""}
    </Button>
  </Col>
</Row>



      <Box sx={{ width: '100%', height: "60vh", zIndex: "0" }} className="mt-2">
        <DataGrid
          rows={BuyersList}
          columns={columnsBuyer}
          rowsPerPageOptions={[3]}
          loading={isLoading}
          checkboxSelection
          onRowSelectionModelChange={item => {
            filterDataBasedId(item)
        }}        />
      </Box>
    </div>
  )
}
